import { createFormContext } from "@mantine/form";
import type { Championship } from "championship/types/championship.model";

export const [
  ChampionshipFormProvider,
  useChampionshipFormContext,
  useChampionshipForm,
] = createFormContext<Omit<Championship, "id">>();
